import { render, staticRenderFns } from "./MzLoading.vue?vue&type=template&id=5b54b846&"
import script from "./MzLoading.vue?vue&type=script&lang=js&"
export * from "./MzLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports